import { render, staticRenderFns } from "./TagSettings.vue?vue&type=template&id=42aee9c6&"
import script from "./TagSettings.vue?vue&type=script&lang=js&"
export * from "./TagSettings.vue?vue&type=script&lang=js&"
import style0 from "./TagSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports